import { render, staticRenderFns } from "./CertificateTabNavigation.vue?vue&type=template&id=75cd506a&scoped=true"
import script from "./CertificateTabNavigation.vue?vue&type=script&lang=js"
export * from "./CertificateTabNavigation.vue?vue&type=script&lang=js"
import style0 from "./CertificateTabNavigation.vue?vue&type=style&index=0&id=75cd506a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cd506a",
  null
  
)

export default component.exports